export default __webpack_public_path__ + "static/media/logo-branco.ce8e4edf.svg";